import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function PaymentsNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isValid = /^\d+(\.\d{0,2})?$/.test(control.value);
        return isValid ? null : { 'paymentsNumberInvalid': true };
    };
}
